export default "__VITE_ASSET__CnAOVxKi__"